import { AfterViewInit, Component, EventEmitter, Input, Output, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { IMCMapView } from '../../../classes/mcMapView';
import { baseScaleIntervals } from '../../../selectionOptions';
import { LayerService } from '../../../services/layer.service';
import { MapCoreLayer } from '../../../types';
import { BaseComponent } from '../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-min-max-scale',
    styleUrls: ['../../sharedStyles/base.scss', './min-max-scale.component.scss'],
    templateUrl: './min-max-scale.component.html'
})
export class MinMaxScaleComponent extends BaseComponent implements AfterViewInit {

    windowRef: any;
    @Output() readonly onclose: EventEmitter<void> = new EventEmitter();

    esriLayer: MapCoreLayer;
    @Input() mapViewRef: IMCMapView;

    private _uniqueLayerId;
    @Input() set uniqueLayerId(value) {
        this._uniqueLayerId = value;
        if (this._uniqueLayerId) {
            this.esriLayer = this.layerService.getEsriLayerByUniqueId(this._uniqueLayerId);

            if (this.esriLayer) {
                if (this.esriLayer.mapcoreProps.originalMinScale) {
                    this.removeLayerPreset(this.startScaleIntervals);
                    if (this.esriLayer.mapcoreProps.originalMinScale !== 0) {
                        this.addLayerPreset(this.startScaleIntervals, this.esriLayer.mapcoreProps.originalMinScale);
                    }
                } else if (typeof this.esriLayer.minScale === 'number') {
                    this.removeLayerPreset(this.startScaleIntervals);
                    if (this.esriLayer.minScale !== 0) {
                        this.addLayerPreset(this.startScaleIntervals, this.esriLayer.minScale);
                    }
                }

                if (this.esriLayer.mapcoreProps.originalMaxScale) {
                    this.removeLayerPreset(this.stopScaleIntervals);
                    if (this.esriLayer.mapcoreProps.originalMaxScale !== 0) {
                        this.addLayerPreset(this.stopScaleIntervals, this.esriLayer.mapcoreProps.originalMaxScale);
                    }
                } else if (typeof this.esriLayer.maxScale === 'number') {
                    this.removeLayerPreset(this.stopScaleIntervals);
                    if (this.esriLayer.maxScale !== 0) {
                        this.addLayerPreset(this.stopScaleIntervals, this.esriLayer.maxScale);
                    }
                }
            }
        }
    }
    get uniqueLayerId() {
        return this._uniqueLayerId;
    }

    startScaleIntervals = [
        {
            label: 'None',
            value: 0
        },
        ...baseScaleIntervals
    ];
    stopScaleIntervals = [
        {
            label: 'None',
            value: 0
        },
        ...baseScaleIntervals
    ];

    constructor(_vcr: ViewContainerRef, private readonly layerService: LayerService) {
        super(_vcr, true);
        this.registerEvent('onclose', this.onclose);
    }

    async ngAfterViewInit() {
        this.mapViewRef = await this.setupMapViewRef(this.mapViewRef);
    }

    reset() {
        this.esriLayer.minScale = this.esriLayer.mapcoreProps.originalMinScale != undefined ? this.esriLayer.mapcoreProps.originalMinScale : 0;
        this.esriLayer.maxScale = this.esriLayer.mapcoreProps.originalMaxScale != undefined ? this.esriLayer.mapcoreProps.originalMaxScale : 0;

        this.removeLayerPreset(this.startScaleIntervals);
        if (this.esriLayer.mapcoreProps.originalMinScale !== 0) {
            this.addLayerPreset(this.startScaleIntervals, this.esriLayer.mapcoreProps.originalMinScale);
        }
        this.removeLayerPreset(this.stopScaleIntervals);
        if (this.esriLayer.mapcoreProps.originalMaxScale !== 0) {
            this.addLayerPreset(this.stopScaleIntervals, this.esriLayer.mapcoreProps.originalMaxScale);
        }
    }

    private addLayerPreset(intervals, scaleValue) {
        const currentInterval = intervals.find(interval => (interval.value === scaleValue));
        const changedInterval = { label: `Layer Preset - ${currentInterval.label}`, value: currentInterval.value };
        const currentIntervalIndex = intervals.findIndex(interval => (interval.value === scaleValue));

        intervals[currentIntervalIndex] = changedInterval;
    }

    private removeLayerPreset(intervals) {
        const preset = intervals.find(interval => interval.label.includes('Layer Preset'));
        if (preset) {
            const originalInterval = baseScaleIntervals.find(interval => (interval.value === preset.value));
            const presetIndex = intervals.findIndex(interval => (interval.value === preset.value));

            intervals[presetIndex] = originalInterval;
        }
    }

    close() {
        this.onclose.emit();
    }
}
